import { render, staticRenderFns } from "./detailsOfSympathy.vue?vue&type=template&id=60b31670&scoped=true"
import script from "./detailsOfSympathy.vue?vue&type=script&lang=js"
export * from "./detailsOfSympathy.vue?vue&type=script&lang=js"
import style0 from "./detailsOfSympathy.vue?vue&type=style&index=0&id=60b31670&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b31670",
  null
  
)

export default component.exports